module.exports = __webpack_public_path__ + "assets/img/industrial_head.fc8cc6fa.svg";